import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vuelidate from 'vuelidate';
import VueMask from 'v-mask';
import VMoney from 'v-money';
import VTooltip from 'v-tooltip';
import ToastifyMixin from './mixins/ToastifyMixin';

import './config/AppComponentsConfig';
import './config/AppDirectivesConfig';
import './config/AppFiltersConfig';
import './config/MomentConfig';
import './config/BuefyConfig';

Vue.config.productionTip = false;

Vue.mixin(ToastifyMixin);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(VMoney);
Vue.use(VTooltip);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
